export default __webpack_public_path__ + "static/media/05_Business-Portrait-EschweilerPhotography_21A9937_1.48eeb84a.jpg";